module.exports = __webpack_public_path__ + "assets/3e0ddac7672bafbd7c101bcd1911ef36.png";